import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/showPdpFulfillmentSelector/show/showSelector';

const showPdpFulfillmentSelectorSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => {
    const globalKillswitch = !!Sephora?.configurationSettings?.pdpFulfillmentSelector?.isEnabled;

    return globalKillswitch && testReady && show;
});

export { showPdpFulfillmentSelectorSelector };
